import React, { useEffect, useState } from "react";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import Footer from "../../../sections/Footer";
import Navbar from "../../../sections/Navbar";
import { FiShare2 } from "react-icons/fi";
import GaleryProduct, { images } from "./GaleryProduct";
import ProductSimilary from "./ProductSimilary";
import { useParams } from "react-router-dom";
import { useLazyProductBySlugQuery } from "../../../utils/api/product/product.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { Color } from "../../../utils/theme";
import Swal from "sweetalert2";
import Fade from "react-reveal/Fade";
import { addCartProduct } from "../../../redux/slice/useCartSlice";
import { useGetVendeurByApiKeyQuery } from "../../../utils/api/product/product.api";
import Skeleton from "react-loading-skeleton";
import { formatCurrency } from "../../../utils/Utils";
import { VendeurApikey } from "../../../utils/http";
import { getVendeur } from "../../HomePage/HomePage";
import {
  detailPageBuyButtonsEnabled,
  effectiveStockForCartSelection,
  getMaxSelectableQuantity,
  isVariationStockUnlimited,
  variationHasAvailableStock,
} from "../../../utils/productStock";

const ProduitItemPage = ({ min = 0, max = 5000, step = 1 }) => {
  const Vendeur = getVendeur();

  const dispatch = useAppDispatch();

  const [item] = images;

  const { slug } = useParams<{ slug: string }>();
  const [variationActive, setVariationActive] = useState<any>();
  const [variations, setVariations] = useState<any>([]);
  const [validation, setValidation] = useState<boolean>(false);
  const [showValidation, setShowValidation] = useState<boolean>(false);
  const [imagesProduit, setImagesProduit] = useState<any>();
  const [tailles, setTailles] = useState<any>();
  const [tailleActive, setTailleActive] = useState<any>();
  const [findBySlug, { data, isLoading }] = useLazyProductBySlugQuery();
  const navigate = useNavigate();
  const [count, setCount] = React.useState(1);
  const maxLength = 324;
  const [isExpanded, setIsExpanded] = useState(false);

  const isTruncated = data?.description.length > maxLength;

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (slug) {
      findBySlug(slug as string);
    }
  }, [slug]);

  const handalevalidation = () => {
    setValidation(false);
    setShowValidation(true);
    setTimeout(() => {
      setShowValidation(false);
    }, 3000);
  };

  useEffect(() => {
    const vars = data?.variations;
    const firstVariation =
      Array.isArray(vars) && vars.length > 0
        ? vars.find((v) => variationHasAvailableStock(v))
        : undefined;

    if (
      data?.type == "taille_unique" ||
      data?.type == "taille_unique_avec_couleur"
    ) {
      setValidation(true);
      setShowValidation(false);
    }

    if (firstVariation) {
      setVariationActive(firstVariation);
      setVariations([firstVariation]);
    } else {
      setVariationActive(null);
      setVariations([]);
    }
  }, [data]);

  useEffect(() => {
    setImagesProduit(variationActive?.images);
    setTailles(
      data?.variations?.filter(
        (x) =>
          x.couleur == variationActive?.couleur &&
          variationHasAvailableStock(x)
      )
    );
  }, [variationActive]);

  function SuccessPopup() {
    Swal.fire({
      icon: "success",
      iconColor: Color.success,
      confirmButtonColor: Color.success,
      title: "Produit ajouté au panier avec succès !",
      showConfirmButton: false,
      timer: 3000,
    });
  }

  const ajouterAuPanier = async () => {
    findBySlug(slug as string);

    let taux =
      data?.categorie?.promotion?.taux ||
      data?.sous_categorie?.promotion?.taux ||
      data?.promotion?.taux;

    let produit = {
      produit: data,
      prix:
        data?.promotion?.is_active ||
        data?.categorie?.promotion?.is_active ||
        data?.sous_categorie?.promotion?.is_active
          ? data?.prix - (data?.prix * taux) / 100
          : parseInt(data?.prix),
      quantite: count,
      stock: effectiveStockForCartSelection(data, variationActive),
      variations: variations,
      vendeur: data?.vendeur?.id,
    };

    dispatch(addCartProduct(produit));
    SuccessPopup();
  };

  const onSelectColor = (item) => {
    setVariationActive(item);
    setVariations([item]);
    if (
      data?.type == "taille_unique" ||
      data?.type == "taille_unique_avec_couleur"
    ) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  };

  const onSelectSize = (item) => {
    setTailleActive(item?.taille);
    setVariations([item]);
    setValidation(true);
  };

  const ColorVariationItem = ({
    color,
    isActive,
    variation,
  }: {
    color: string;
    isActive?: boolean;
    variation?: any;
  }) => {
    return (
      <div
        className={
          variationActive?.id == isActive ? "btn_color_wrapper" : "btn_color"
        }
      >
        <label
          role="button"
          className={`btn btn_color_choose`}
          style={{ background: color }}
          onClick={() => onSelectColor(variation)}
        ></label>
        <input
          type="radio"
          name="variation_color"
          id="variation_color"
          value={variation?.id}
        />
      </div>
    );
  };

  const SizeVariationItem = ({
    size,
    variation,
  }: {
    size: string;
    variation: any;
  }) => {
    return (
      <label
        role="button"
        className={
          variation?.taille == tailleActive
            ? "btn btn_size_choose active "
            : "btn btn_size_choose"
        }
        onClick={() => onSelectSize(variation)}
      >
        <input
          type="radio"
          name="variation_size"
          id="variation_size"
          value={variation?.id}
        />
        {size}
      </label>
    );
  };

  const decrement = (e) => {
    setCount((prevValue) => Math.max(prevValue - step, min));
  };

  const increment = (e) => {
    setCount((prevValue) => {
      if (!data) return Math.min(prevValue + step, max);
      const cap = getMaxSelectableQuantity(data, variationActive);
      const uiCap = cap >= Number.MAX_SAFE_INTEGER ? 5000 : cap;
      return Math.min(prevValue + step, uiCap, max);
    });
  };

  const handleChange = (e) => {
    const inputValue = parseInt(e.target.value, 10);
    if (!isNaN(inputValue)) {
      if (!data) {
        setCount(Math.min(Math.max(inputValue, min), max));
        return;
      }
      const cap = getMaxSelectableQuantity(data, variationActive);
      const uiCap = cap >= Number.MAX_SAFE_INTEGER ? 5000 : cap;
      setCount(Math.min(Math.max(inputValue, min), Math.min(uiCap, max)));
    } else {
      setCount(0);
    }
  };

  const acheterMaintenant = () => {
    if (!validation) {
      handalevalidation();
      return;
    }
    const taux =
      data?.categorie?.promotion?.taux ||
      data?.sous_categorie?.promotion?.taux ||
      data?.promotion?.taux;
    const produit = {
      produit: data,
      prix:
        data?.promotion?.is_active ||
        data?.categorie?.promotion?.is_active ||
        data?.sous_categorie?.promotion?.is_active
          ? data?.prix - (data?.prix * taux) / 100
          : parseInt(data?.prix),
      quantite: count,
      stock: effectiveStockForCartSelection(data, variationActive),
      variations: variations,
      vendeur: data?.vendeur?.id,
    };
    dispatch(addCartProduct(produit));
    navigate("/valider-commande");
  };

  const handleShare = async () => {
    const productUrl = `${window.location.origin}/produit/${data?.slug}`;
    const shareText = `Découvrez ${data?.nom} - ${formatCurrency(data?.prix, Vendeur?.devise)}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: data?.nom,
          text: shareText,
          url: productUrl,
        });
      } catch {
        // Partage annulé ou erreur
      }
    } else {
      try {
        await navigator.clipboard.writeText(productUrl);
        Swal.fire({
          icon: "success",
          title: "Lien copié !",
          text: "Le lien du produit a été copié dans le presse-papiers.",
          iconColor: Color.success,
          showConfirmButton: false,
          timer: 2000,
        });
      } catch {
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: "Impossible de copier le lien.",
          iconColor: Color.danger,
        });
      }
    }
  };

  const rawMaxQty = data
    ? getMaxSelectableQuantity(data, variationActive)
    : 0;
  const displayMaxQty =
    rawMaxQty >= Number.MAX_SAFE_INTEGER
      ? 5000
      : Math.max(0, rawMaxQty);
  const buyButtonsEnabled = data
    ? detailPageBuyButtonsEnabled(data, count, variationActive, validation)
    : false;

  return (
    <div className="">
      <Navbar />
      <div className="page-content bg-white ">
        <div className="container-easy-market container-easy-market--product-detail">
          <Fade bottom>
            <div
              className="content-back-to pb-3 pt-0 flex items-center gap-2"
              onClick={(e) => {
                e?.preventDefault();
                navigate(-1);
              }}
            >
              <HiOutlineArrowLeft className="shrink-0" size={18} aria-hidden />
              <span className="go-back-btn leading-none">RETOUR</span>
            </div>
          </Fade>
          {isLoading && (
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3 dis-flex" key={0}>
                <div className="item-stat-dashboad-view">
                  <div className="content-item-stat-dashboad-view mt-2">
                    <div className="content-item-icon-stat-dashboard-view">
                      <Skeleton className="img-icon-dash-view" width={`70%`} />
                      <Skeleton className="img-icon-dash-view" width={`70%`} />
                    </div>
                  </div>
                  <div className="content-stat-dashboard-view">
                    <div className="content-text-item-stat-dashboad-view">
                      <div className="icon-item-stat-dashboad-view">
                        <Skeleton className="chiffre-item-stat-dashboad-view mb-1" width={`50%`} />
                        <Skeleton className="chiffre-item-stat-dashboad-view mb-1" width={`50%`} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 mb-3 dis-flex" key={0}>
                <div className="item-stat-dashboad-view">
                  <div className="content-item-stat-dashboad-view mt-2">
                    <Skeleton className="titre-item-stat-dashboad-view mb-2" width={`70%`} />
                    <Skeleton className="titre-item-stat-dashboad-view mb-2" width={`50%`} />
                    <Skeleton className="titre-item-stat-dashboad-view mb-2" width={`30%`} />
                  </div>
                  <div className="content-stat-dashboard-view">
                    <div className="content-text-item-stat-dashboad-view">
                      <div className="icon-item-stat-dashboad-view">
                        <Skeleton className="chiffre-item-stat-dashboad-view mb-1" width={`50%`} />
                        <Skeleton className="titre-item-stat-dashboad-view mb-2" width={`70%`} />
                        <Skeleton className="titre-item-stat-dashboad-view mb-2" width={`50%`} />
                        <Skeleton className="chiffre-item-stat-dashboad-view mb-1" width={`50%`} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {!isLoading && (
            <div className="row row-product-item-page b-b-1 mb-3 pb-4">
              <div className="col-lg-6 col-md-12 col-left-product-item-page d-flex">
                <div className="content-col-left-product-item-page container-product-item-page">
                  <GaleryProduct
                    pictures={
                      data?.type == "taille_unique"
                        ? data?.images
                        : data?.variations && data?.variations[0]?.images
                        ? imagesProduit
                          ? imagesProduit
                          : data?.variations[0]?.images
                        : null
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-left-product-item-page d-flex">
                <div className="content-col-left-product-item-page container-product-item-page">
                  <Fade bottom>
                    <h1 className="name-product mb-2">{data?.nom}</h1>
                  </Fade>
                  <Fade bottom>
                    <p className="category-product-name mb-1">
                      Categorie: {data?.categorie?.nom}
                    </p>
                  </Fade>
                  <div className="custom_container container-product-description pb-4">
                    <Fade bottom>
                      <p className="custom_sm__title">Description</p>
                    </Fade>
                    <Fade bottom>
                      <>
                        <pre className="text-describe-product-item-detail py-3">
                          {isExpanded || !isTruncated
                            ? data?.description
                            : `${data?.description.slice(0, maxLength)}...`}
                        </pre>
                        {isTruncated && (
                          <button onClick={toggleExpanded} className="btn btn-see-more-product">
                            {isExpanded ? "Voir moins" : "Voir plus"}
                          </button>
                        )}
                      </>
                    </Fade>
                  </div>
                  <div className="custom_container container-product-price pb-4">
                    <Fade bottom>
                      {data?.promotion?.is_active ||
                      data?.categorie?.promotion?.is_active ||
                      data?.sous_categorie?.promotion?.is_active ? (
                        <>
                          <span className="custom_sm__price_promos pb-3">
                            {formatCurrency(
                              data?.prix -
                                (data?.prix *
                                  (data?.categorie?.promotion?.taux ||
                                    data?.sous_categorie?.promotion?.taux ||
                                    data?.promotion?.taux)) /
                                  100,
                              Vendeur?.devise
                            )}
                          </span>
                          <span className="custom_sm__price_promos_bare pb-3">
                            {formatCurrency(data?.prix, Vendeur?.devise)}
                          </span>
                        </>
                      ) : (
                        <p className="custom_sm__price pb-3">
                          {formatCurrency(data?.prix, Vendeur?.devise)}
                        </p>
                      )}
                    </Fade>
                  </div>
                  {data?.variations?.length > 0 ? (
                    <div className="custom_container variation_content container-product-colors pb-4">
                      <Fade bottom>
                        <p className="m-0 pb-2 custom_sm__title">Couleur</p>
                      </Fade>
                      <Fade bottom>
                        <div className="d-flex align-items-center gap-3 avalaible_colors_wrapper">
                          {!!data?.variations &&
                            data?.variations
                              ?.filter((value) => variationHasAvailableStock(value))
                              ?.filter(
                                (value, index, self) =>
                                  self.findIndex((v) => v.couleur === value.couleur) === index
                              )
                              ?.map((item, key) => (
                                <ColorVariationItem
                                  color={item.couleur}
                                  isActive={item.id}
                                  variation={item}
                                  key={key}
                                />
                              ))}
                        </div>
                      </Fade>
                    </div>
                  ) : (
                    ""
                  )}
                  {data?.type != "taille_unique" &&
                  data?.type != "taille_unique_avec_couleur" ? (
                    <div className="custom_container variation_content container-product-sizes pb-3">
                      <Fade bottom>
                        <p className="m-0 pb-2 custom_sm__title">Taille</p>
                      </Fade>
                      <Fade bottom>
                        <div className="d-flex align-items-center gap-3 avalaible_sizes_wrapper">
                          {!!tailles &&
                            tailles.map((item, key) => (
                              <SizeVariationItem
                                size={item.taille}
                                variation={item}
                                key={key}
                              />
                            ))}
                        </div>
                      </Fade>
                    </div>
                  ) : (
                    ""
                  )}
                  {showValidation && (
                    <div className="alert alert-danger mt-1" role="alert">
                      Veillez choisir une taille
                    </div>
                  )}
                  <div className="container-quantite-produit mb-4">
                    <p className="title-quantity-product">Quantité</p>
                    <div className="btn-wrap">
                      <button
                        className="btn decrement-btn btn-counter-item"
                        disabled={count <= 1}
                        onClick={(e) => decrement(e)}
                      >
                        −
                      </button>
                      <div className="num">
                        <input
                          type="number"
                          value={count}
                          onChange={handleChange}
                          className="input-counter-item"
                        />
                      </div>
                      {count < displayMaxQty && displayMaxQty > 0 && (
                          <button
                            className="btn increment-btn btn-counter-item"
                            onClick={(e) => increment(e)}
                          >
                            +
                          </button>
                        )}
                    </div>
                  </div>
                  {variationActive &&
                    !isVariationStockUnlimited(variationActive) &&
                    count > Number(variationActive?.quantite ?? 0) && (
                    <div className="alert alert-danger mt-1" role="alert">
                      {Number(variationActive?.quantite ?? 0) > 0
                        ? `La quantité maximale est de ${variationActive?.quantite}`
                        : `Cette variation est en rupture de stock`}
                    </div>
                  )}
                  <div className="container-quantite-produit">
                    <p className="title-quantity-product">Total</p>
                    <p className="title-quantity-product">
                      {formatCurrency(
                        (data?.promotion?.is_active ||
                        data?.categorie?.promotion?.is_active ||
                        data?.sous_categorie?.promotion?.is_active
                          ? data?.prix -
                            (data?.prix *
                              (data?.categorie?.promotion?.taux ||
                                data?.sous_categorie?.promotion?.taux ||
                                data?.promotion?.taux)) /
                              100
                          : data?.prix) * count,
                        Vendeur?.devise
                      )}
                    </p>
                  </div>
                  <div className="container-btn-add-to-cart-product mt-4">
                    <div className="product-action-buttons-row">
                      {buyButtonsEnabled ? (
                        <>
                          <button
                            className="btn btn-buy-now"
                            onClick={() =>
                              validation ? acheterMaintenant() : handalevalidation()
                            }
                          >
                            Acheter maintenant
                          </button>
                          <button
                            className="btn btn-add-to-cart"
                            onClick={() =>
                              validation ? ajouterAuPanier() : handalevalidation()
                            }
                          >
                            Ajouter au panier
                          </button>
                        </>
                      ) : (
                        <>
                          <button className="btn btn-buy-now" disabled>
                            Acheter maintenant
                          </button>
                          <button className="btn btn-add-to-cart" disabled>
                            Ajouter au panier
                          </button>
                        </>
                      )}
                    </div>
                    <div className="product-secondary-buttons-row">
                      <button
                        type="button"
                        className="btn btn-share"
                        onClick={handleShare}
                      >
                        <FiShare2 />
                        <span className="ps-2">Partager</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <ProductSimilary product={data} />
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default ProduitItemPage;